export function displayTranscriptTitle(
  title: string,
  dateOrTimestamp: string | number | Date = new Date()
): string {
  if (title.trim()) return title;
  const date = new Date(dateOrTimestamp);
  const label = Number.isNaN(date.valueOf())
    ? new Date().toLocaleString()
    : date.toLocaleString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
      });
  return "Untitled transcript · " + label;
}
